import EventRegisterForm from "../../components/admin/EventRegisterForm";
import EventSearchActivate from "../../components/admin/EventSearchActivate";

export default function AdminHome() {
  return (
    <div className="md:mx-2 p-4 space-y-6">
      <div className="flex flex-col gap-6 md:flex-row md:items-start md:gap-6">
        <div className="min-w-0 flex-1">
          <EventRegisterForm />
        </div>
        <div className="min-w-0 flex-1">
          <EventSearchActivate />
        </div>
      </div>
    </div>
  );
}
